/* eslint-disable react/prop-types */
import { Link } from "@bond-london/gatsby-plugin-cms-i18next";
import {
  EmbedRenderer,
  IEmbedNodeRendererProps,
  ILinkNodeRendererProps,
  LinkRenderer,
} from "@bond-london/graphcms-rich-text";
import React, { PropsWithChildren, lazy, useEffect, useState } from "react";

const ReactPlayer = lazy(() => import("react-player/lazy"));

export function isVideoUrl(url: string) {
  return url.includes("vimeo.com") || url.includes("youtube.com");
}
export const RTFLinkRenderer: React.FC<{
  props: PropsWithChildren<ILinkNodeRendererProps>;
}> = ({ props }) => {
  const [hasWindow, setHasWindow] = useState(false);
  useEffect(() => {
    if (typeof window !== "undefined") {
      setHasWindow(true);
    }
  }, []);

  if (props.nodeType) {
    return (
      <EmbedRenderer
        {...(props as unknown as IEmbedNodeRendererProps)}
        isInline={true}
      />
    );
  }
  const href = props.href as unknown as string;
  if (href) {
    if (href.startsWith("/")) {
      return (
        <Link to={href} className={props.classNameOverrides?.a}>
          {props.children}
        </Link>
      );
    }

    if (isVideoUrl(href)) {
      return (
        <div className="aspect-h-9 aspect-w-16 w-full">
          {hasWindow && (
            <ReactPlayer
              url={href}
              playsinline={true}
              width="100%"
              height="100%"
              playing={true}
              light
              controls
            />
          )}
        </div>
      );
    }
  }

  return <LinkRenderer {...props} />;
};
